import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import PageLoading from "./PageLoading";
import "./css/layout.css";

export default function AdminLayout() {
  return (
    <>
      <Header />
      <main className="admin-main-content">
        {/* Keeps header and sidebar in place while a lazily loaded page downloads. */}
        <Suspense fallback={<PageLoading message="Loading page" />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </>
  );
}
